import { render, staticRenderFns } from "./times.vue?vue&type=template&id=645284b6&scoped=true"
import script from "./times.vue?vue&type=script&lang=js"
export * from "./times.vue?vue&type=script&lang=js"
import style0 from "./times.vue?vue&type=style&index=0&id=645284b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645284b6",
  null
  
)

export default component.exports